<template>
  <CRow class="justify-content-center">
    <Modal :modal="modal"></Modal>

    <!-- Content -->
    <CCol col="12">
      <CForm @submit.prevent="send">
        <CRow>
          <CCol lg="12">
            <div class="d-flex align-items-center justify-content-end mb-3">
              <a
                href="javascript:void(0)"
                @click="$router.go(-1)"
              ><CIcon
                name="cil-arrow-left"
                class="mr-2"
              />Voltar</a>
            </div>
          </CCol>
        </CRow>
        <!-- Fields -->
        <CCard>
          <CCardHeader
            class="d-flex justify-content-between align-items-center"
          >
            <h4 class="mb-0">
              {{ $route.params.id ? 'Editar Área de Interesse' : 'Cadastrar Área de Interesse' }}
            </h4>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol lg="12">
                <CInput
                  v-model="form.name"
                  label="Nome*"
                  placeholder="Nome da área interesse"
                  required
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        <!-- Actions -->
        <div class="form-actions">
          <a
            href="javascript:void(0)"
            class="mr-3"
            @click="clearEdit"
          >Limpar alterações</a>
          <CButton
            color="success"
            type="submit"
            :disabled="processing"
          >
            {{ processing ? 'Salvando...' : 'Salvar' }}
          </CButton>
        </div>
      </CForm>
    </CCol>
  </CRow>
</template>

<script>
// components
import Modal from '@/components/ui/Modal'

// dependencies
import InterestService from '@/services/interest.service'

import { cloneDeep } from 'lodash'

export default {
  metaInfo: {
    title: 'Parâmetros - Áreas de interesse',
    titleTemplate: ' %s - Manager - Intelli'
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.state.auth.permissions.includes('manage_work_with_us')) {
        vm.$router.push('/404')
      }
    })
  },

  components: {
    Modal
  },

  data() {
    return {
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      processing: false,
      query: {
        sorter: {}
      },
      modal: {
        show: false,
        title: '',
        message: '',
        color: ''
      },
      interest: {
        name: ''
      },
      form: {}
    }
  },

  watch: {
  },

  async created() {
    if (this.$route.params.id) {
      await this.setInterestData()
    }
  },

  methods: {

    async setInterestData() {
      if (this.$route.params.id) {
        const response = await InterestService.getInterestInformation(
          this.$route.params.id
        )

        this.interest = {
          ...response
        }
      }

      this.setFormData()
    },

    setFormData() {
      this.form = cloneDeep(this.interest)
    },

    clearEdit() {
      this.setInterestData()
    },

    async send() {
      this.processing = true

      let response
      let message

      const data = {
        ...this.form
      }

      if (this.$route.params.id) {
        response = await InterestService.updateInterest(this.$route.params.id, data)
        message = 'A área de interesse foi atualizada com sucesso!'
      } else {
        response = await InterestService.storeInterest(data)
        message = 'A área de interesse foi cadastrada com sucesso!'
        this.new = false
      }

      this.processing = false

      if (response.status === 200) {
        this.modal = {
          show: true,
          title: 'Sucesso',
          message: message,
          color: 'success',
          redirect: true
        }

        setTimeout(() => {
          this.$router.push(
            this.$route.matched[this.$route.matched.length - 2].path
          )
        }, 3000)
      } else if (response.status === 400) {
        this.modal = {
          show: true,
          title: 'Erro',
          message: `${
            response.data.length > 0
              ? response.data[0].message
              : 'Preencha todos os campos corretamente!'
          }`,
          color: 'danger'
        }
      } else {
        this.modal = {
          show: true,
          title: 'Erro',
          message: 'Ocorreu um erro interno, por favor tente novamente!',
          color: 'danger'
        }
      }
    }
  }
}
</script>
